<template>
<m-pageframe
    title="{organization-label}: My Apps"
>
<v-container
    fluid
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickCreateNewApp()"
                >
                    <v-list-item-title>Create New App...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickEdit(item)"
                >
                    <v-list-item-title>Edit...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickViewInstalls(item)"
                >
                    <v-list-item-title>View Installations...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickAppCredentials(item)"
                >
                    <v-list-item-title>App Credentials (API Keys)...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickNewVersion(item)"
                >
                    <v-list-item-title>Create New Version...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            full_text: null,
            results: [],

            headers: [
                { text: 'Label', value: 'app_label'},
                { text: 'Version', value: 'version'},
                { text: 'State', value: 'state'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/apps/my-apps',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to list your apps',
            });
        },
        

        onClickCreateNewApp() 
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/apps/my-apps/create-stub',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                    },
            
                'on_success': (data) => {
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to create new application',
            });    
        },

        onClickEdit(item)
        {
            this.$router.push({
                'name': 'developer-edit-app',
                'params' : {
                    'organization_id': item.organization_id,
                    'app_id': item.app_id,
                    'version': item.version,
                }
            });
        },

        onClickNewVersion(item)
        {
            this.$rc.confirm({
                'title': 'Create a New App Version',
                'body': 'Create a new version of '+item.app_label+"?",
                'btn_text_ok': 'Create New Version',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doCreateNewVersion(item);
                },
            });
        },

        doCreateNewVersion(item)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/apps/my-apps/new-version',
            
                'params' : item,
            
                'on_success': (data) => {
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to create new version',
            });
        },

        onClickViewInstalls(item)
        {
            this.$router.push({
                'name': 'developer-search-app-installs',
                'params' : item
            });
        },

        onClickAppCredentials(item)
        {
            this.$router.push({
                'name': 'developer-app-credentials',
                'params' : item
            });
        },
    },
}
</script>

<style lang="scss" scoped>
</style>